// redux/invoiceSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import apiFetch from "../../utlis/apiFetch"

export const fetchInvoices = createAsyncThunk(
    "invoices/fetchInvoices",
    async ({ page, limit, filters } = {}, thunkAPI) => {
        try {
            const token = localStorage.getItem("token");
            if (!token) throw new Error("No authentication token found");
            let url = `${process.env.REACT_APP_API_BASE_URL}/api/application/getInvoices`;
            const params = new URLSearchParams();
            if (page) params.append('page', page);
            if (limit) params.append('limit', limit);
            if (filters && typeof filters === 'object') {
                Object.entries(filters).forEach(([key, value]) => {
                    if (value !== undefined && value !== null && value !== "") {
                        params.append(key, value);
                    }
                });
            }
            const query = params.toString();
            if (query) url += `?${query}`;

            const response = await apiFetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            const data = response._data ?? await response.json()

            if (!response.ok) {
                throw new Error(data.message || "Failed to fetch invoices")
            }

            // Backend now returns an object with pagination metadata in data.body
            // Keep backwards compatibility: if body is an array, return it directly
            if (!data.body) return [];
            return data.body;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message || "Network error")
        }
    }
)

export const updateTransaction = createAsyncThunk(
    "invoices/uploadTransaction",
    async (
        { applicationId, transactionId, transactionDate, file, paymentMethod },
        { rejectWithValue }
    ) => {
        try {
            console.log("-------------------------"+paymentMethod+"-------------------------")
            const token = localStorage.getItem("token");
            if (!token) throw new Error("No authentication token found");

            const formData = new FormData();
            formData.append("applicationId", applicationId);
            formData.append("transactionId", transactionId);
            formData.append("transactionDate", transactionDate);
            formData.append("paymentMethod",paymentMethod);
            formData.append("other", file);

            const response = await apiFetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/application/updateInvoice`,
                {
                    method: "PUT",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    body: formData,
                }
            );

            const data = response._data ?? await response.json();
            if (!response.ok) throw new Error(data.message || "Something went wrong");

            return data.body;
        } catch (error) {
            return rejectWithValue(error.message || "Upload failed");
        }
    }
)

const invoiceSlice = createSlice({
    name: "invoices",
    initialState: {
        invoices: [],
        loading: false,
        error: null,
        isSubmitting: false,
        success: null,
        // pagination metadata
        totalPages: 1,
        currentPage: 1,
        totalInvoices: 0,
    },
    reducers: {
        resetSuccess: (state) => {
            state.success = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInvoices.pending, (state) => {
                state.loading = true
                state.error = null
            })
            .addCase(fetchInvoices.fulfilled, (state, action) => {
                // action.payload may be an array (old behaviour) or an object with { invoices, totalPages, currentPage, totalInvoices }
                if (Array.isArray(action.payload)) {
                    state.invoices = action.payload;
                    state.totalPages = 1;
                    state.currentPage = 1;
                    state.totalInvoices = action.payload.length;
                } else if (action.payload && action.payload.invoices) {
                    state.invoices = action.payload.invoices;
                    state.totalPages = action.payload.totalPages || 1;
                    state.currentPage = action.payload.currentPage || 1;
                    state.totalInvoices = action.payload.totalInvoices || 0;
                } else {
                    state.invoices = [];
                    state.totalPages = 1;
                    state.currentPage = 1;
                    state.totalInvoices = 0;
                }
                state.loading = false
            })
            .addCase(fetchInvoices.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload
            })

            // uploadTransaction handlers
            .addCase(updateTransaction.pending, (state) => {
                state.isSubmitting = true;
                state.error = null;
                state.success = null;
            })
            .addCase(updateTransaction.fulfilled, (state, action) => {
                state.isSubmitting = false;
                state.success = "Transaction uploaded successfully!";
                state.error = null;

                // Note: We'll dispatch resetSuccess from middleware or component
            })
            .addCase(updateTransaction.rejected, (state, action) => {
                state.isSubmitting = false;
                state.error = action.payload || "Upload failed";
            });
    },
});
export const { resetSuccess } = invoiceSlice.actions;
export default invoiceSlice.reducer;
